module.exports = __webpack_public_path__ + "img/bubble.506ff159.jpg";